import { useState } from "react";
import LoginView from "./LoginView";
import SignUpView from "./SignUpView";
import ForgotPasswordView from "./ForgotPasswordView";

interface AuthDialogContentProps {
  initialView?: string;
  onClose: ()=>void;
}

const AuthDialogContent = ({ initialView , onClose}: AuthDialogContentProps) => {
  const [view, setView] = useState(localStorage.getItem("hasAccount") ? "login" : initialView || "signup");
  const searchParams = new URLSearchParams(window.location.search);
  const invitation_code = searchParams.get("invitation_code") ?? undefined;

  return (
    <>
      {view === "signup" && <SignUpView setView={setView} onClose={onClose} invitation_code={invitation_code}/>}
      {view === "login" && <LoginView setView={setView} onClose={onClose} invitation_code={invitation_code}/>}
      {view === "forgot" && <ForgotPasswordView setView={setView} />}
    </>
  );
};

export default AuthDialogContent;
